(function () {
  'use strict';
  svgedit.history = svgedit.history || {};

  svgedit.history.RemoveElementCommand = function (elem, oldNextSibling, oldParent, text) {
    this.elem = elem;
    this.text = text || ('Delete ' + elem.tagName);
    this.nextSibling = oldNextSibling;
    this.parent = oldParent;

    svgedit.transformlist.removeElementFromListMap(elem);
  };
  svgedit.history.RemoveElementCommand.type = function () { return 'svgedit.history.RemoveElementCommand'; };
  svgedit.history.RemoveElementCommand.prototype.type = svgedit.history.RemoveElementCommand.type;

  svgedit.history.RemoveElementCommand.prototype.getText = function () {
    return this.text;
  };

  svgedit.history.RemoveElementCommand.prototype.apply = function (handler) {
    handler && handler.handleHistoryEvent(svgedit.history.HistoryEventTypes.BEFORE_APPLY, this);

    svgedit.transformlist.removeElementFromListMap(this.elem);
    this.parent = this.elem.parentNode;
    this.elem = this.parent.removeChild(this.elem);

    handler && handler.handleHistoryEvent(svgedit.history.HistoryEventTypes.AFTER_APPLY, this);
  };

  svgedit.history.RemoveElementCommand.prototype.unapply = function (handler) {
    handler && handler.handleHistoryEvent(svgedit.history.HistoryEventTypes.BEFORE_UNAPPLY, this);

    svgedit.transformlist.removeElementFromListMap(this.elem);
    if (this.nextSibling == null) {
      console.log('Error: reference element was lost');
    }

    this.parent.insertBefore(this.elem, this.nextSibling);

    handler && handler.handleHistoryEvent(svgedit.history.HistoryEventTypes.AFTER_UNAPPLY, this);
  };

  svgedit.history.RemoveElementCommand.prototype.elements = function () {
    return [this.elem];
  };
})();
